import React from 'react';
import { Helmet } from 'react-helmet';
import { useRootSelector } from '../../../../store/hooks';
import { selectLocationConfig } from '../../../../store/features/locationConfig';
import { InformaMetaTagPageType } from '../../../../constants';

export interface MetaTagsProps {
  title: string;
  titleSuffix?: string;
  description?: string;
  thumbnail?: string;
  robots?: string;
  canonicalUrl?: string;
  informaPageType?: InformaMetaTagPageType;
  informaPageId?: string;
}

export function MetaTags(props: MetaTagsProps) {
  const {
    title,
    titleSuffix,
    description,
    thumbnail,
    robots,
    canonicalUrl,
    informaPageId,
    informaPageType,
  } = props;
  const { origin, pathname } = useRootSelector(selectLocationConfig);

  const url = [origin, pathname].join('');
  const logo = [origin, thumbnail].filter(Boolean).join('');
  const heading = [title, titleSuffix].filter(Boolean).join(' | ');

  return (
    <Helmet>
      <title>{heading}</title>
      <meta name="description" content={description} />
      {logo && <meta name="thumbnail" content={logo} />}
      {robots && <meta name="robots" content={robots} />}
      <meta property="og:title" content={heading} />
      <meta property="og:description" content={description} />
      {logo && <meta property="og:image" content={logo} />}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <link rel="canonical" href={canonicalUrl ?? url} />
      {informaPageId && <meta name="informa-page-id" content={informaPageId} />}
      {informaPageType && (
        <meta name="informa-page-type" content={informaPageType} />
      )}
    </Helmet>
  );
}
